"use strict";

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ApiMethods = /*#__PURE__*/function () {
  function ApiMethods(api) {
    _classCallCheck(this, ApiMethods);

    this.api = api; //
  } // account


  _createClass(ApiMethods, [{
    key: "getConnectedAccounts",
    value: function getConnectedAccounts() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.api.sendRequest({
        method: 'GET',
        path: "account?page=".concat(page || 0)
      });
    }
  }, {
    key: "getAccount",
    value: function getAccount(address) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(address)
      });
    }
  }, {
    key: "searchAccount",
    value: function searchAccount(ensName) {
      return this.api.sendRequest({
        method: 'POST',
        path: 'account/search',
        body: {
          ensName: ensName
        }
      });
    }
  }, {
    key: "createAccount",
    value: function createAccount(ensName) {
      return this.api.sendRequest({
        method: 'POST',
        path: 'account',
        body: {
          ensName: ensName || null
        }
      });
    }
  }, {
    key: "updateAccountEnsName",
    value: function updateAccountEnsName(accountAddress, ensName) {
      return this.api.sendRequest({
        method: 'PUT',
        path: "account/".concat(accountAddress),
        body: {
          ensName: ensName
        }
      });
    }
  }, {
    key: "estimateAccountDeployment",
    value: function estimateAccountDeployment(accountAddress, gasPriceStrategy) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.api.sendRequest({
                  method: 'POST',
                  path: "account/".concat(accountAddress, "/deploy"),
                  body: {
                    gasPriceStrategy: gasPriceStrategy
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "deployAccount",
    value: function deployAccount(accountAddress, gasPrice, guardianSignature) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$this$api$sendR, hash;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.api.sendRequest({
                  method: 'PUT',
                  path: "account/".concat(accountAddress, "/deploy"),
                  body: {
                    gasPrice: gasPrice,
                    guardianSignature: guardianSignature
                  }
                });

              case 2:
                _yield$this$api$sendR = _context2.sent;
                hash = _yield$this$api$sendR.hash;
                return _context2.abrupt("return", hash);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    } // account device

  }, {
    key: "getAccountDevices",
    value: function getAccountDevices(accountAddress) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/device?page=").concat(page)
      });
    }
  }, {
    key: "getAccountDevice",
    value: function getAccountDevice(accountAddress, address) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/device/").concat(address)
      });
    }
  }, {
    key: "createAccountDevice",
    value: function createAccountDevice(accountAddress, address, type) {
      return this.api.sendRequest({
        method: 'POST',
        path: "account/".concat(accountAddress, "/device"),
        body: {
          type: type || null,
          device: address
        }
      });
    }
  }, {
    key: "updateAccountDevice",
    value: function updateAccountDevice(accountAddress, address, type) {
      return this.api.sendRequest({
        method: 'PUT',
        path: "account/".concat(accountAddress, "/device/").concat(address),
        body: {
          type: type
        }
      });
    }
  }, {
    key: "removeAccountDevice",
    value: function removeAccountDevice(accountAddress, address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$this$api$sendR2, success;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.api.sendRequest({
                  method: 'DELETE',
                  path: "account/".concat(accountAddress, "/device/").concat(address)
                });

              case 2:
                _yield$this$api$sendR2 = _context3.sent;
                success = _yield$this$api$sendR2.success;
                return _context3.abrupt("return", success);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    } // account friend recovery

  }, {
    key: "getAccountFriendRecovery",
    value: function getAccountFriendRecovery(accountAddress) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/friend-recovery")
      });
    }
  }, {
    key: "submitAccountFriendRecovery",
    value: function submitAccountFriendRecovery(accountAddress, friends, signatures, gasPrice, guardianSignature) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _yield$this$api$sendR3, hash;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.api.sendRequest({
                  method: 'PUT',
                  path: "account/".concat(accountAddress, "/friend-recovery"),
                  body: {
                    friends: friends,
                    signatures: signatures,
                    gasPrice: gasPrice,
                    guardianSignature: guardianSignature
                  }
                });

              case 2:
                _yield$this$api$sendR3 = _context4.sent;
                hash = _yield$this$api$sendR3.hash;
                return _context4.abrupt("return", hash);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    } // account game

  }, {
    key: "getAccountGames",
    value: function getAccountGames(accountAddress, app) {
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/game?page=").concat(page, "&app=").concat(app)
      });
    }
  }, {
    key: "getAccountGame",
    value: function getAccountGame(accountAddress, id) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/game/").concat(id)
      });
    }
  }, {
    key: "createAccountGame",
    value: function createAccountGame(accountAddress, app, deposit, data) {
      return this.api.sendRequest({
        method: 'POST',
        path: "account/".concat(accountAddress, "/game"),
        body: {
          app: app,
          deposit: deposit,
          data: data
        }
      });
    }
  }, {
    key: "joinAccountGame",
    value: function joinAccountGame(accountAddress, id, signature) {
      return this.api.sendRequest({
        method: 'PUT',
        path: "account/".concat(accountAddress, "/game/").concat(id),
        body: {
          signature: signature
        }
      });
    }
  }, {
    key: "startAccountGame",
    value: function startAccountGame(accountAddress, id, signature) {
      return this.api.sendRequest({
        method: 'PUT',
        path: "account/".concat(accountAddress, "/game/").concat(id),
        body: {
          signature: signature
        }
      });
    }
  }, {
    key: "updateAccountGame",
    value: function updateAccountGame(accountAddress, id, data) {
      return this.api.sendRequest({
        method: 'PUT',
        path: "account/".concat(accountAddress, "/game/").concat(id),
        body: {
          data: data
        }
      });
    }
  }, {
    key: "cancelAccountGame",
    value: function cancelAccountGame(accountAddress, id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$this$api$sendR4, success;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.api.sendRequest({
                  method: 'DELETE',
                  path: "account/".concat(accountAddress, "/game/").concat(id)
                });

              case 2:
                _yield$this$api$sendR4 = _context5.sent;
                success = _yield$this$api$sendR4.success;
                return _context5.abrupt("return", success);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    } // account payment

  }, {
    key: "getAccountPayments",
    value: function getAccountPayments(accountAddress, page, state) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/payment?page=").concat(page, "&state=").concat(state)
      });
    }
  }, {
    key: "getAccountPayment",
    value: function getAccountPayment(accountAddress, hash) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/payment/").concat(hash)
      });
    }
  }, {
    key: "createAccountPayment",
    value: function createAccountPayment(accountAddress, recipient, token, value) {
      return this.api.sendRequest({
        method: 'POST',
        path: "account/".concat(accountAddress, "/payment"),
        body: {
          recipient: recipient,
          value: value,
          token: token || null
        }
      });
    }
  }, {
    key: "signAccountPayment",
    value: function signAccountPayment(accountAddress, hash, signature) {
      return this.api.sendRequest({
        method: 'PUT',
        path: "account/".concat(accountAddress, "/payment/").concat(hash),
        body: {
          signature: signature
        }
      });
    }
  }, {
    key: "grabAccountPayment",
    value: function grabAccountPayment(accountAddress, hash, recipient) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.api.sendRequest({
                  method: 'PUT',
                  path: "account/".concat(accountAddress, "/payment/").concat(hash),
                  body: {
                    recipient: recipient
                  }
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "cancelAccountPayment",
    value: function cancelAccountPayment(accountAddress, hash) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _yield$this$api$sendR5, success;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.api.sendRequest({
                  method: 'DELETE',
                  path: "account/".concat(accountAddress, "/payment/").concat(hash)
                });

              case 2:
                _yield$this$api$sendR5 = _context7.sent;
                success = _yield$this$api$sendR5.success;
                return _context7.abrupt("return", success);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    } // account transaction

  }, {
    key: "getAccountTransactions",
    value: function getAccountTransactions(accountAddress) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/transaction?page=").concat(page, "&hash=").concat(hash)
      });
    }
  }, {
    key: "getAccountTransaction",
    value: function getAccountTransaction(accountAddress, hash) {
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/transaction/").concat(hash, "?index=").concat(index)
      });
    }
  }, {
    key: "estimateAccountProxyTransaction",
    value: function estimateAccountProxyTransaction(accountAddress, data, gasPriceStrategy) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!Array.isArray(data)) {
                  data = [data];
                }

                _context8.next = 3;
                return this.api.sendRequest({
                  method: 'POST',
                  path: "account/".concat(accountAddress, "/transaction"),
                  body: {
                    data: data,
                    gasPriceStrategy: gasPriceStrategy
                  }
                });

              case 3:
                result = _context8.sent;
                return _context8.abrupt("return", Object.assign({}, result, {
                  data: data
                }));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "submitAccountProxyTransaction",
    value: function submitAccountProxyTransaction(accountAddress, data, signature, gasPrice, guardianSignature) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _yield$this$api$sendR6, hash;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.api.sendRequest({
                  method: 'PUT',
                  path: "account/".concat(accountAddress, "/transaction"),
                  body: {
                    data: data,
                    gasPrice: gasPrice,
                    signature: signature,
                    guardianSignature: guardianSignature
                  }
                });

              case 2:
                _yield$this$api$sendR6 = _context9.sent;
                hash = _yield$this$api$sendR6.hash;
                return _context9.abrupt("return", hash);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    } // account virtual balance

  }, {
    key: "getAccountVirtualBalances",
    value: function getAccountVirtualBalances(accountAddress) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/virtual-balance?page=").concat(page)
      });
    }
  }, {
    key: "getAccountVirtualBalance",
    value: function getAccountVirtualBalance(accountAddress, tokenAddressOrSymbol) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/virtual-balance/").concat(tokenAddressOrSymbol)
      });
    }
  }, {
    key: "getAccountVirtualPendingBalances",
    value: function getAccountVirtualPendingBalances(accountAddress) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/virtual-balance/pending")
      });
    }
  }, {
    key: "getAccountVirtualPendingBalance",
    value: function getAccountVirtualPendingBalance(accountAddress, tokenAddressOrSymbol) {
      return this.api.sendRequest({
        method: 'GET',
        path: "account/".concat(accountAddress, "/virtual-balance/pending/").concat(tokenAddressOrSymbol)
      });
    } // app

  }, {
    key: "getApps",
    value: function getApps() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.api.sendRequest({
        method: 'GET',
        path: "app?page=".concat(page)
      });
    }
  }, {
    key: "getApp",
    value: function getApp(alias) {
      return this.api.sendRequest({
        method: 'GET',
        path: "app/".concat(alias)
      });
    }
  }, {
    key: "getAppOpenGames",
    value: function getAppOpenGames(alias) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.api.sendRequest({
        method: 'GET',
        path: "app/".concat(alias, "/game?page=").concat(page)
      });
    } // tokens

  }, {
    key: "getTokens",
    value: function getTokens() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.api.sendRequest({
        method: 'GET',
        path: "token?page=".concat(page)
      });
    }
  }, {
    key: "getToken",
    value: function getToken(symbolOrAddress) {
      return this.api.sendRequest({
        method: 'GET',
        path: "token/".concat(symbolOrAddress)
      });
    }
  }]);

  return ApiMethods;
}();

exports.ApiMethods = ApiMethods;